export enum MediaSource {
  Camera,
  Video,
  Gallery,
  File
}
